export default "__VITE_ASSET__DAkMSZDH__"